
import React from "react";
import PlansPageLayout from "@/components/plans/PlansPageLayout";

const PlansPage = () => {
  return <PlansPageLayout />;
};

export default PlansPage;
